<template>
  <!-- Use hide-details to avoid scroll-y of header!!!! -->
  <div class="d-flex align-center">
    <icon-text-btn
      @onClick="onOpen"
      :icon="'mdi-file-table-box-outline'"
      :text="text ? text : 'Kurs wählen'"
      :hint="'Kurs, Linie auf einer Linien-/Kurs Matrix auswählen'"
      :iconColor="theme.appBar.other.color"
      :small="small"
      :noWrap="noWrap"
    ></icon-text-btn>

    <v-dialog v-model="isOpen" :fullscreen="!!xs" :close-on-content-click="false" offset-y class="font-size" :minWidth="xs ? '100vw' : '800px'">
      <v-card>
        <v-card-title>
          <date-list-picker
            :color="color"
            v-model="selectedDateIndex"
            v-if="sortedDatesIsoStrings.length"
            :availableDateIsoStringsSorted="sortedDatesIsoStrings"
            @onDateSelected="onDateSelected"
            class="mr-3"
          ></date-list-picker>

          <v-btn class="mr-3" rounded @click="selectToday">{{ $t('today') }}</v-btn>

          <v-text-field class="ml-5" :label="'Filter'" :placeholder="$t('typeToFilter')" v-model="filter" clearable></v-text-field>
          <v-spacer></v-spacer>
          <v-btn icon @click="isOpen = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="isOpen" :style="`font-size:${$store.state.profile.userProfile.baseFontSize}px`">
          <div class="text-h5 text-no-wrap py-3">Linien / Kurse {{ selectedDate }}</div>
          <div class="scroll-container" style="overflow-x: auto; height: 70vh">
            <table>
              <template>
                <tr :key="line + '_'" v-for="line in Object.keys(linesByTracks.lines)">
                  <td class="line">Linie {{ line }}</td>
                  <td
                    v-ripple
                    @click="select(line, track)"
                    class="line-track-cell track"
                    :style="`color:${getColor(track)}`"
                    v-for="track in lineTracks(line)"
                    :key="line + '_' + track"
                    v-html="cellValue(line, track)"
                  ></td>
                </tr>
              </template>
            </table>
          </div>
          <!-- </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import common from '@/mixins/common';
import DateListPicker from '@/components/pickers/DateListPicker';
import dateUtils from '../../common/dateUtils';
import IconTextBtn from '@/components/buttons/IconTextBtn.vue';

export default {
  name: 'DateLineTrackMatrix',
  mixins: [common],
  props: {
    dayLineTracks: Array,
    value: Object,
    color: String,
    text: String /* Optional display text */,
    trackStartsWithLine: { type: Boolean, default: false },
    small: { type: Boolean, default: true },
    noWrap: { type: Boolean, default: false },
  },
  components: {
    DateListPicker,
    IconTextBtn,
  },
  data() {
    return {
      dataValue: this.value,
      isOpen: false,
      tableHtml: '',
      selectedDateIndex: 0,
      filter: null,
    };
  },
  created() {
    if (this.dataValue && this.dataValue.value) {
      this.selectedDateIndex = this.sortedDatesIsoStrings.findIndex((d) => d === this.dataValue.value.day);
    }

    if (!this.selectedDateIndex || this.selectedDateIndex < 0) {
      this.selectedDateIndex = 0;
    }
  },
  computed: {
    selectedDateIsoString() {
      return this.sortedDatesIsoStrings[this.selectedDateIndex];
    },
    selectedDateTime() {
      return this.selectedDateIsoString ? Date.parse(this.selectedDateIsoString) : null;
    },
    selectedDate() {
      return dateUtils.formatAsLocaleNamedShortDate(new Date(this.selectedDateTime));
    },
    datesIsoStrings() {
      let dateTimes = {};
      this.dayLineTracks.forEach((d) => (dateTimes[d.value.dateTime] = d));
      return Object.keys(dateTimes)
        .map((d) => new Date(Number(d)).toISOString())

        .filter((d) => d !== undefined);
    },
    sortedDatesIsoStrings() {
      return [...this.datesIsoStrings].sort((a, b) => new Date(a) - new Date(b));
    },
    normalizedFilter() {
      if (typeof this.filter !== 'string' || !this.filter) {
        return this.filter || '';
      }
      const trimmed = this.filter.trim();
      if (/^\d+$/.test(trimmed)) {
        return trimmed.replace(/^0+/, '') || '0';
      }
      return trimmed;
    },
    linesByTracks() {
      let matrixObj = {};
      let lines = {};

      this.dayLineTracks
        .filter((d) => d.value.dateTime === this.selectedDateTime)
        .forEach((i) => {
          let trackId = i.value.track;
          let lineId = i.value.line;
          lines[lineId] = lineId;

          let line = matrixObj[lineId];
          if (!line) {
            line = {};
            matrixObj[lineId] = line;
          }
          line[trackId] = i;

          // check if we need to throwaway this item because it is filtered
          if (this.normalizedFilter) {
            let findings = Object.keys(line).filter((trackNo) => {
              let value = line[trackNo] && line[trackNo].value ? line[trackNo].value : {};
              return `${value.line}`.indexOf(this.normalizedFilter) < 0 && `${value.track}`.indexOf(this.normalizedFilter) < 0;
            });
            if (findings.length === Object.keys(line).length) {
              delete lines[lineId];
            } else {
              findings.forEach((trackNo) => {
                delete line[trackNo];
              });
            }
          }
        });
      return { lines, matrix: matrixObj };
    },
  },
  methods: {
    getSelectedDateIndex(value) {
      if (value.value && !!value.value.day) {
        let d = value.value.day;

        let selectedDateIndex = this.sortedDatesIsoStrings.findIndex((iso) => iso.includes(d));
        if (!selectedDateIndex || selectedDateIndex < 0) {
          return 0;
        }
        return selectedDateIndex;
      }
      return 0;
    },
    onOpen() {
      this.$nextTick(() => {
        this.isOpen = true;
        if (this.dataValue && this.dataValue.value && !this.dataValue.value.day) {
          this.$nextTick(() => {
            console.debug('selectToday');
            this.selectToday();
          });
        }
      });
    },
    getColor(track) {
      if (this.dataValue && this.dataValue.value) {
        return `${this.dataValue.value.track}` === `${track}` ? 'red' : '';
      }
      return null;
    },
    onDateSelected(selectedDateIndex) {
      this.selectedDateIndex = selectedDateIndex;
    },

    select(line, track) {
      this.$emit('input', this.linesByTracks.matrix[line][track]);
      this.isOpen = false;
    },
    selectToday() {
      let now = new Date(Date.now());
      let index = this.sortedDatesIsoStrings.findIndex((dateIsoString) => dateUtils.isSameDate(now, dateUtils.parseISOString(dateIsoString)));
      if (index >= 0) {
        this.selectedDateIndex = index;
      }
    },

    cellValue(lineId, trackId) {
      let f = this.normalizedFilter;
      let line = this.linesByTracks.matrix[lineId];
      if (line) {
        let track = `${line[trackId].value.track}`;
        let ind = this.normalizedFilter ? track.indexOf(f) : -1;
        if (ind < 0) return track;
        return track.substring(0, ind) + '<span style="color:red">' + f + '</span>' + track.substring(ind + f.length);
      }
      return '';
    },
    lineTracks(line) {
      return this.trackStartsWithLine
        ? Object.keys(this.linesByTracks.matrix[line])
            .filter((k) => String(k).startsWith(String(line)))
            .sort()
        : Object.keys(this.linesByTracks.matrix[line]).sort();
    },
  },

  watch: {
    value: {
      handler(newValue) {
        this.dataValue = newValue;
        this.selectedDateIndex = this.getSelectedDateIndex(newValue);
      },
      deep: true,
      immediate: true,
    },

    dataValue(newValue) {
      this.$emit('input', newValue);
    },
    isOpen() {
      this.filter = null;
    },
  },
};
</script>
<style scoped>
.font-size {
  font-size: 1.4em !important;
}

.line,
.track {
  white-space: nowrap;
  text-align: center;
  padding: 8px;
}

.line {
  text-align: left;
  font-weight: 800;
}
.theme--light .line-track-cell {
  border-radius: 8px;
  background: #e0e0e0;
}
.theme--dark .line-track-cell {
  border-radius: 5px;
  background: #303030;
}
</style>
